import React from "react";
import { Text, Textarea } from "@mantine/core";
import { Controller, Control, FieldErrors } from "react-hook-form";
import { MantineProvider } from "@mantine/core";

interface TextAeraRefProps {
  name: string;
  label: string;
  errors: FieldErrors<any>;
  control: Control<any>;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
}

const TextAreaRef: React.FC<TextAeraRefProps> = ({
  name,
  label,
  errors,
  control,
  required = true,
  disabled = false,
  placeholder = "",
}) => {
  return (
    <MantineProvider>
      <Controller
        name={name}
        control={control}
        rules={{ required }}
        render={({ field }) => (
          <Textarea
            label={label}
            disabled={disabled}
            placeholder={placeholder}
            {...field}
          />
        )}
      />
      {errors?.[name]?.type === "required" && (
        <Text size="sm" style={{ color: "red" }}>
          This field is required
        </Text>
      )}
    </MantineProvider>
  );
};

export default TextAreaRef;
